import { apiService } from './apiService'
import { inviteEndpoints } from '../api/apiEndpoint'
import { DefaultResponse } from '@/common/types/common'
import { CompanyUserInvite } from '@/common/types/invitation'
import { RegisterUserRequest } from './authService'

export const inviteService = {
  async getInviteInfoForCompanyUser(
    notificationId: string
  ): Promise<CompanyUserInvite | null> {
    try {
      const response = await apiService.get<CompanyUserInvite>(
        inviteEndpoints.getInviteInfoForCompanyUser(notificationId)
      )
      return response as CompanyUserInvite
    } catch (err: any) {
      console.error(err)
      return null
    }
  },

  async acceptInviteForRegister(
    data: RegisterUserRequest
  ): Promise<DefaultResponse | null> {
    try {
      const response = await apiService.patch<DefaultResponse>(
        inviteEndpoints.acceptInveteForRegister(),
        data
      )
      return response
    } catch (err: any) {
      console.error(err)
      return null
    }
  },

  async acceptInviteForLogin(
    notificationId: string
  ): Promise<DefaultResponse | null> {
    try {
      const response = await apiService.patch<DefaultResponse>(
        inviteEndpoints.acceptInviteForLogin(notificationId)
      )
      return response
    } catch (err: any) {
      console.error(err)
      return null
    }
  },

  async rejectInvite(data: {
    notificationId: string
    reason: string
  }): Promise<DefaultResponse | null> {
    try {
      const response = await apiService.patch<DefaultResponse>(
        inviteEndpoints.rejectInvite(data.notificationId)
      )
      return response
    } catch (err: any) {
      console.error(err)
      return null
    }
  }
}
